(function () {
  const announcementSlider = () => {
    $(".announcement-bar__slide").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      if ($(".announcement-bar")) {
        $(this).addClass("slider_started");
      }

      const $slideContainer = $(this);
      const announcementId = $slideContainer.data("announcement-id");
      const userTimeZone = +$slideContainer.data("timezone") || 0;
      const $swiperContainer = $(`.announcement-js-${announcementId}`);
      const $fallbackContent = $slideContainer.find(
        ".announcement-bar__fallback"
      );
      const $navigationButtons = $slideContainer.find(".swiper-button");

      // Get current time with timezone offset
      let date = new Date();
      let utcTime = date.getTime();
      let timezoneOffset = date.getTimezoneOffset();
      let offsetInMilliseconds = timezoneOffset * 60 * 1000;
      let targetTimezoneOffset = userTimeZone * 60;
      let targetOffsetInMilliseconds = targetTimezoneOffset * 60 * 1000;
      let targetTime =
        utcTime + offsetInMilliseconds + targetOffsetInMilliseconds;
      let currentDate = new Date(targetTime);

      // Check each slide for date range validity
      const $allSlides = $slideContainer.find(
        ".announcement-bar__message.swiper-slide"
      );
      let activeSlides = [];

      $allSlides.each(function () {
        const $slide = $(this);
        const startDate = $slide.data("start-date");
        const startTime = $slide.data("start-time") || "00:00";
        const endDate = $slide.data("end-date");
        const endTime = $slide.data("end-time") || "23:59";

        // Check if slide should be active based on date range
        let isActive = true;

        if (startDate && startDate.trim() !== "") {
          const slideStartDate = new Date(`${startDate}T${startTime}`);
          if (currentDate < slideStartDate) {
            isActive = false;
          }
        }

        if (endDate && endDate.trim() !== "" && isActive) {
          const slideEndDate = new Date(`${endDate}T${endTime}`);
          if (currentDate > slideEndDate) {
            isActive = false;
          }
        }

        if (isActive) {
          activeSlides.push($slide);
          $slide.show();
        } else {
          $slide.hide();
        }
      });

      // Handle display logic
      if (activeSlides.length > 0) {
        // Show swiper container and hide fallback
        $swiperContainer.show();
        $fallbackContent.hide();

        // Show/hide navigation based on active slide count
        if (activeSlides.length > 1) {
          $navigationButtons.show();
        } else {
          $navigationButtons.hide();
        }

        // Initialize or update Swiper
        const swiperSelector = `.announcement-js-${announcementId}`;

        // Destroy existing swiper if it exists
        if (window.swiperInstances && window.swiperInstances[announcementId]) {
          window.swiperInstances[announcementId].destroy(true, true);
        }

        // Initialize new swiper
        const announcementSwiper = new Swiper(swiperSelector, {
          loop: activeSlides.length > 1,
          navigation: {
            nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
            prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
          },
          autoplay:
            activeSlides.length > 1
              ? {
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
          on: {
            afterInit: (swiper) => syncSwiperSlideAccessibility(swiper, { hideInactive: true }),
            transitionEnd: (swiper) => syncSwiperSlideAccessibility(swiper, { hideInactive: true }),
            loopFix: (swiper) => syncSwiperSlideAccessibility(swiper, { hideInactive: true }),
          },
        });

        if (activeSlides.length > 1 && announcementSwiper.autoplay) {
          const slideContainer = $slideContainer[0];
          slideContainer.addEventListener("focusin", () =>
            announcementSwiper.autoplay.stop()
          );
          slideContainer.addEventListener("focusout", (event) => {
            if (!slideContainer.contains(event.relatedTarget)) {
              announcementSwiper.autoplay.start();
            }
          });
        }

        // Store swiper instance for cleanup
        if (!window.swiperInstances) {
          window.swiperInstances = {};
        }
        window.swiperInstances[announcementId] = announcementSwiper;
      } else {
        // No active slides, show fallback content
        $swiperContainer.hide();
        $navigationButtons.hide();
        $fallbackContent.show();
      }
    });
  };

  // Run on initial load
  announcementSlider();

  // Run when section is loaded/updated
  document.addEventListener("shopify:section:load", function () {
    announcementSlider();
  });

  // Update every minute to check for date changes
  setInterval(announcementSlider, 60000);
})();
